/**
 * Workspace settings & members — OWNER and ADMIN only.
 * CREATOR (and others) are redirected to Network Workbench home or Agentic.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.jsx';
import { canAccessNetworkWorkbench, canAccessWorkspaceAdmin } from '@/utils/stepflowRoles';

export default function RequiresWorkspaceAdminAccess({ children }) {
  const { workspaceRole } = useAuth();
  if (canAccessWorkspaceAdmin(workspaceRole)) {
    return children;
  }
  const fallback = canAccessNetworkWorkbench(workspaceRole) ? '/network/new' : '/agentic';
  return <Navigate to={fallback} replace />;
}
